/* eslint-disable no-console */
import { register } from 'register-service-worker'

// Function to create and show update notification
const showUpdateNotification = () => {
  // Create notification element
  const notification = document.createElement('div');
  notification.style.cssText = `
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: #4CAF50;
    color: white;
    padding: 15px 20px;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    z-index: 9999;
    display: flex;
    align-items: center;
    gap: 10px;
  `;

  // Create message
  const message = document.createElement('span');
  message.textContent = 'New version available!';
  notification.appendChild(message);

  // Create update button
  const updateButton = document.createElement('button');
  updateButton.textContent = 'Update Now';
  updateButton.style.cssText = `
    background: white;
    color: #4CAF50;
    border: none;
    padding: 5px 10px;
    border-radius: 3px;
    cursor: pointer;
    font-weight: bold;
  `;
  updateButton.onclick = () => {
    forceUpdate();
  };
  notification.appendChild(updateButton);

  // Add to document
  document.body.appendChild(notification);

  // Auto-hide after 30 seconds
  setTimeout(() => {
    notification.style.opacity = '0';
    notification.style.transition = 'opacity 0.5s ease';
    setTimeout(() => notification.remove(), 500);
  }, 30000);
};

// Function to get the current version from the service worker
const getCurrentVersion = async () => {
  try {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) {
      return registration.active?.scriptURL || '';
    }
  } catch (error) {
    console.error('Error getting service worker version:', error);
  }
  return null;
};

// Function to check if we should show the update notification
const shouldShowUpdateNotification = async () => {
  const newVersion = await getCurrentVersion();
  if (!newVersion) return true;
  
  const storedVersion = localStorage.getItem('sw-version');
  
  // If we haven't stored a version yet, store it and don't show notification
  if (!storedVersion) {
    localStorage.setItem('sw-version', newVersion);
    return false;
  }
  
  // Only show notification if the version has changed
  return newVersion !== storedVersion;
};

// Function to force update the service worker
const forceUpdate = async () => {
  try {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) {
      // Unregister the current service worker
      await registration.unregister();
      
      // Clear all caches
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames.map(cacheName => caches.delete(cacheName))
        );
      }
      
      // Clear localStorage version
      localStorage.removeItem('sw-version');
      
      // Force reload
      window.location.reload(true);
    }
  } catch (error) {
    console.error('Error during force update:', error);
  }
};

// Clear caches and service worker on initial load
const clearExistingServiceWorker = async () => {
  try {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) {
      await registration.unregister();
    }
    
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames.map(cacheName => caches.delete(cacheName))
      );
    }
    
    localStorage.removeItem('sw-version');
  } catch (error) {
    console.error('Error clearing service worker:', error);
  }
};

// Clear existing service worker on initial load
clearExistingServiceWorker();

register(`${process.env.BASE_URL}service-worker.js`,
  {
    ready () {
      console.log('App is being served from cache by a service worker.')
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      // Check for updates periodically instead of immediately
      setInterval(() => {
        registration.update();
      }, 1000 * 60 * 60); // Check for updates every hour
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    async updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available.')
      // Store the new version
      getCurrentVersion().then(version => {
        if (version) {
          localStorage.setItem('sw-version', version);
          // Show update notification
          showUpdateNotification();
        }
      });
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  }
)

